const defaultTimeout = 10000;

export default {
	emit(type, message, timeout=null) {
		$bus.$emit("notify", "NotificationAlert", { type, message, timeout });
	},
	info(message, timeout=null) {
		this.emit("info", message, timeout);
	},
	success(message, timeout=defaultTimeout) {
		this.emit("success", message, timeout);
	},
	warning(message, timeout=defaultTimeout) {
		this.emit("warning", message, timeout);
	},
	error(message, response=null, timeout=defaultTimeout) {
		if ((((response || {}).data || {}).error || {}).message)
			message += `: ${response.data.error.message} (${response.data.error.code})`;
		else if (response && response.status && response.statusText)
			message += `: ${response.statusText} (${response.status})`;

		this.emit("error", message, timeout);
	}
};
